import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Typography,
} from "@mui/material";
import PropTypes from "prop-types";
import React from "react";

function ExampleCard(props) {
  const { example, onClick } = props;

  // Render
  return (
    <Card
      variant="outlined"
      style={{
        overflow: "auto",
        position: "relative",
        minHeight: "100%",
        minWidth: "100%",
      }}
      sx={{
        minWidth: 700,
        minHeight: 0,
      }}
    >
      <CardActionArea onClick={onClick}>
        <CardContent>
          <Typography
            sx={{
              textAlign: "center",
              color: "accent.main",
            }}
            variant="overline"
            component="h6"
          >
            {example.name}
          </Typography>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: 5,
            }}
          >
            {example.images.map((image) => {
              return (
                <CardMedia
                  key={image}
                  component="img"
                  height="200"
                  class=".MuiCardMedia-img"
                  image={image}
                  alt={`Preview of example ${example.name}`}
                  sx={{
                    objectFit: "contain",
                  }}
                />
              );
            })}
          </Box>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}

ExampleCard.propTypes = {
  example: PropTypes.shape({
    name: PropTypes.string.isRequired,
    images: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
};

export default ExampleCard;
